export const observabilityMessages = {
  auditLoadFailed: 'Failed to load audit logs',
  eventsCount: '{count} events',
  searchAudit: 'Search action, target, detail',
  allActions: 'All Actions',
  auditActionLinkCreate: 'Link Create',
  auditActionLinkUpdate: 'Link Update',
  auditActionLinkDelete: 'Link Delete',
  auditActionImportConfirm: 'Import Confirm',
  auditActionShlinkFetch: 'Shlink API Fetch',
  auditActionBackupCreate: 'Backup Create',
  auditActionApiTokenCreate: 'API Token Create',
  auditActionApiTokenRevoke: 'API Token Revoke',
  noAuditEvents: 'No audit events found',
  detail: 'Detail',
  userAgent: 'User Agent',
  analyticsSubtitle: 'Traffic, attribution, targets, and conversions',
  exportCsv: 'Export CSV',
  analyticsLoadFailed: 'Failed to load analytics',
  reportDownloaded: 'Analytics report downloaded',
  reportDownloadFailed: 'Failed to download analytics report',
  autoRefresh: 'Auto refresh',
  autoRefreshInterval: 'Auto-refresh interval',
  refreshAnalyticsNow: 'Refresh analytics now',
  analyticsUpdatedAt: 'Updated {time}',
  analyticsWaitingForUpdate: 'Waiting for data',
  range: 'Range',
  reset: 'Reset',
  uniqueVisitors: 'Unique Visitors',
  uniqueLinks: 'Unique Links',
  conversions: 'Conversion Events',
  conversionRate: 'Events / Human Clicks',
  conversionInsights: 'Conversion Overview',
  conversionInsightsHint: 'Server-recorded goals, human-click basis, and attributed value',
  conversionIntegrationGuide: 'Integration guide',
  humanClicks: 'Human Clicks',
  eventRate: 'Event Rate',
  eventRateHint:
    'Event rate is conversion events divided by human clicks and may exceed 100% when one click creates multiple events.',
  eventsByGoal: 'Events by goal',
  recordedValue: 'Recorded value',
  noConversionEvents: 'No conversion events in this range.',
  noRecordedValue: 'No conversion value in this range.',
  unspecifiedCurrency: 'Unspecified currency',
  conversionFilterUnavailable:
    'Conversion attribution is unavailable for country, device, browser, or referrer filters.',
  botRate: 'Bot Rate',
  last7: 'Last 7 days',
  last30: 'Last 30 days',
  last90: 'Last 90 days',
  last365: 'Last 365 days',
  slugFilter: 'Slug',
  campaign: 'Campaign',
  project: 'Project',
  country: 'Country',
  device: 'Device',
  allDevices: 'All devices',
  desktop: 'Desktop',
  mobile: 'Mobile',
  tablet: 'Tablet',
  browser: 'Browser',
  referrer: 'Referrer',
  utmSource: 'UTM Source',
  utmMedium: 'UTM Medium',
  utmCampaign: 'UTM Campaign',
  utmTerm: 'UTM Term',
  utmContent: 'UTM Content',
  applyFilters: 'Apply',
  advancedAnalyticsFilters: 'Advanced filters',
  savedViews: 'Saved views',
  savedViewName: 'View name',
  saveCurrentView: 'Save current view',
  deleteSavedView: 'Delete view',
  savedViewCreated: 'Analytics view saved',
  savedViewDeleted: 'Analytics view deleted',
  savedViewsLoadFailed: 'Failed to load saved views',
  scheduledReports: 'Scheduled Analytics Reports',
  scheduledReportsHint: 'The daily Cron stores CSV reports in the configured R2 bucket.',
  enableDailyReports: 'Enable daily reports',
  allAnalytics: 'All Analytics',
  saveSchedule: 'Save schedule',
  runReportNow: 'Run now',
  scheduledReportsSaved: 'Report schedule saved',
  scheduledReportCreated: 'Analytics report created',
  scheduledReportsLoadFailed: 'Failed to load report schedule',
  noScheduledReports: 'No scheduled reports yet.',
  trafficAnomalyAlerts: 'Traffic Anomaly Alerts',
  trafficAnomalyHint:
    'The daily Cron compares the last 24 hours with the previous 7-day daily baseline. Low-volume samples are ignored, and alerts use your configured notification channels.',
  enableTrafficAnomalyAlerts: 'Enable scheduled traffic anomaly alerts',
  trafficMinimumVisits: 'Minimum visits per day',
  trafficVolumeMultiplier: 'Volume spike multiplier',
  trafficBotRateDelta: 'Bot-rate increase (percentage points)',
  trafficSuppressionMinutes: 'Repeat suppression (minutes)',
  saveTrafficAnomalySettings: 'Save alert settings',
  runTrafficAnomalyCheck: 'Check now',
  trafficAnomalySaved: 'Traffic anomaly settings saved',
  trafficAnomalyChecked: 'Traffic anomaly check completed',
  trafficAnomalyLoadFailed: 'Failed to load traffic anomaly alerts',
  trafficAnomalyLastChecked: 'Last checked: {date}',
  trafficAnomalyStatus: 'Status',
  trafficAnomalyDisabled: 'Disabled',
  trafficWithinBaseline: 'Within baseline',
  trafficInsufficientData: 'Insufficient volume',
  trafficNotEvaluated: 'Not evaluated yet',
  trafficVolumeSpike: 'Volume spike',
  trafficBotRateSpike: 'Bot-rate spike',
  trafficVisitEvidence: '24-hour visits vs 7-day daily baseline',
  trafficCurrentVsBaseline: '{current} vs {baseline} ({ratio}x)',
  trafficBotEvidence: '24-hour bot rate vs 7-day baseline',
  trafficBotCurrentVsBaseline: '{current}% vs {baseline}%',
  trafficPrivacyNote:
    'Only aggregate counts and rates are evaluated and stored. No new visitor, IP, or session identifiers are collected.',
  noData: 'No data yet.',
  recentVisits: 'Recent Visits',
  noRecentVisits: 'No recent visits.',
  direct: 'Direct',
  unknown: 'Unknown',
  other: 'Other',
  clicksValue: 'clicks',
  eventsValue: 'events',
  topLinksTitle: 'Top Links',
  redirectTargets: 'Redirect Targets',
  topReferrers: 'Top Referrers',
  conversionEvents: 'Conversion Events',
  utmSources: 'UTM Sources',
  utmMediums: 'UTM Mediums',
  utmCampaigns: 'UTM Campaigns',
  utmTerms: 'UTM Terms',
  utmContents: 'UTM Contents',
  countries: 'Countries',
  globalAccessDistribution: 'Global Access Distribution',
  devices: 'Devices',
  browsers: 'Browsers',
  operatingSystems: 'Operating Systems',
  linkAnalyticsLoadFailed: 'Failed to load link analytics',
  linkReportDownloaded: 'Link report downloaded',
  linkReportDownloadFailed: 'Failed to download link report',
} as const;
